// extracted by mini-css-extract-plugin
export default {"wrapper":"OfflineMsg_wrapper__SjHsM"};